// extracted by mini-css-extract-plugin
export default {"input":"YoSM3A","wrapper":"upVK6t","checkbox":"L8J4Rk","label":"aogfW3"};